/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FunnelDiscountDto } from './FunnelDiscountDto';
import {
    FunnelDiscountDtoFromJSON,
    FunnelDiscountDtoFromJSONTyped,
    FunnelDiscountDtoToJSON,
    FunnelDiscountDtoToJSONTyped,
} from './FunnelDiscountDto';

/**
 * 
 * @export
 * @interface TarificationDto
 */
export interface TarificationDto {
    /**
     * 
     * @type {number}
     * @memberof TarificationDto
     */
    brokerCommission: number;
    /**
     * Price excluding tax in euros
     * @type {number}
     * @memberof TarificationDto
     */
    priceExcludingTax: number;
    /**
     * Tax amount (VAT) in euros
     * @type {number}
     * @memberof TarificationDto
     */
    tax: number;
    /**
     * Sum of additional fees in euros
     * @type {number}
     * @memberof TarificationDto
     */
    feesSum?: number;
    /**
     * Price including all taxes in euros
     * @type {number}
     * @memberof TarificationDto
     */
    priceIncludingTax: number;
    /**
     * Final price charged to the client in euros
     * @type {number}
     * @memberof TarificationDto
     */
    clientPrice: number;
    /**
     * Monthly price including tax for subscriptions in euros
     * @type {number}
     * @memberof TarificationDto
     */
    monthlyPriceIncludingTax?: number;
    /**
     * Total price over 8 years (borrower-specific)
     * @type {number}
     * @memberof TarificationDto
     */
    totalPriceEightYears?: number | null;
    /**
     * Average monthly price (borrower-specific)
     * @type {number}
     * @memberof TarificationDto
     */
    monthPrice?: number | null;
    /**
     * Average yearly price (borrower-specific)
     * @type {number}
     * @memberof TarificationDto
     */
    yearPrice?: number | null;
    /**
     * Average insurance rate
     * @type {number}
     * @memberof TarificationDto
     */
    averageRate?: number;
    /**
     * 
     * @type {FunnelDiscountDto}
     * @memberof TarificationDto
     */
    discount?: FunnelDiscountDto;
}

/**
 * Check if a given object implements the TarificationDto interface.
 */
export function instanceOfTarificationDto(value: object): value is TarificationDto {
    if (!('brokerCommission' in value) || value['brokerCommission'] === undefined) return false;
    if (!('priceExcludingTax' in value) || value['priceExcludingTax'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('priceIncludingTax' in value) || value['priceIncludingTax'] === undefined) return false;
    if (!('clientPrice' in value) || value['clientPrice'] === undefined) return false;
    return true;
}

export function TarificationDtoFromJSON(json: any): TarificationDto {
    return TarificationDtoFromJSONTyped(json, false);
}

export function TarificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TarificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'brokerCommission': json['brokerCommission'],
        'priceExcludingTax': json['priceExcludingTax'],
        'tax': json['tax'],
        'feesSum': json['feesSum'] == null ? undefined : json['feesSum'],
        'priceIncludingTax': json['priceIncludingTax'],
        'clientPrice': json['clientPrice'],
        'monthlyPriceIncludingTax': json['monthlyPriceIncludingTax'] == null ? undefined : json['monthlyPriceIncludingTax'],
        'totalPriceEightYears': json['totalPriceEightYears'] == null ? undefined : json['totalPriceEightYears'],
        'monthPrice': json['monthPrice'] == null ? undefined : json['monthPrice'],
        'yearPrice': json['yearPrice'] == null ? undefined : json['yearPrice'],
        'averageRate': json['averageRate'] == null ? undefined : json['averageRate'],
        'discount': json['discount'] == null ? undefined : FunnelDiscountDtoFromJSON(json['discount']),
    };
}

export function TarificationDtoToJSON(json: any): TarificationDto {
    return TarificationDtoToJSONTyped(json, false);
}

export function TarificationDtoToJSONTyped(value?: TarificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brokerCommission': value['brokerCommission'],
        'priceExcludingTax': value['priceExcludingTax'],
        'tax': value['tax'],
        'feesSum': value['feesSum'],
        'priceIncludingTax': value['priceIncludingTax'],
        'clientPrice': value['clientPrice'],
        'monthlyPriceIncludingTax': value['monthlyPriceIncludingTax'],
        'totalPriceEightYears': value['totalPriceEightYears'],
        'monthPrice': value['monthPrice'],
        'yearPrice': value['yearPrice'],
        'averageRate': value['averageRate'],
        'discount': FunnelDiscountDtoToJSON(value['discount']),
    };
}

